import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/michelin_pilot_road4_trail_tires_detail.jpg")